<lib-privacy-policy [labels]="'lib.privacyPolicy' | translate" [bigTitle]="bigTitle | translate" [dataPrivacy]="dataPrivacy" [contactEmail]="contactEmail"></lib-privacy-policy>
